<template>
  <div class="my-button">
    <button
      v-for="btn in btnConfig.btns"
      :key="btn.value"
      class="button"
      :class="{'is-active': btn.value === btnType}"
      @click="handleClick(btn)"
    >
      {{ $t(btn.text) }}
    </button>
  </div>
</template>

<script>
const defaultBtnCOnfig = {
  default: 'operation',
  btns: [
    { text: 'common.btnTypes[0]', value: 'operation', tableType: 'selection' },
    { text: 'common.btnTypes[1]', value: 'history', tableType: 'index' }
  ]
}
export default {
  props: {
    btnConfig: {
      type: Object,
      default: () => (defaultBtnCOnfig)
    }
  },
  data() {
    return {
      btnType: ''
    }
  },
  created() {
    this.btnType = this.btnConfig.default || ''
  },
  methods: {
    handleClick(val) {
      if (val.value === this.btnType) {
        return
      }
      this.btnType = val.value
      this.$emit('input', val.value)
    }
  }
}
</script>

<style lang="scss" scoped>
$font-color--normal: #ffffff;
$background-color--normal: #333333;
$background-color--active: #92d051;
@mixin base-flex {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
@mixin base-active {
    content: '';
    width: 20px;
    height: 30px;
    background-color: $background-color--active;
    position: absolute;
    border-radius: 2px;
}
.my-button {
  padding-top: 6px;
  padding-right: 17px;
  .button{
    /* 清除按钮默认样式 */
    border:none;
    background-color: transparent;
    outline: none;
    padding: 0 14px;
    width: 87px;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    color: #E1E1E1;
    border-radius: 4px;
    background-color: $background-color--normal;
    @include base-flex;
    height: 26px;
    &.is-active {
      background-color: $background-color--active;
      z-index: 2;
    }
    &:nth-child(1).is-active {
      height: 30px;
      color: #ffffff;
      &::after {
        @include base-active;
        transform: skew(20deg);
        right: -8px;
      }
    }
    &:nth-child(2).is-active {
      height: 30px;
      color: #ffffff;
      &::before {
        border-radius: 2px;
        @include base-active;
        transform: skew(-20deg);
        left: -8px;
      }
    }
  }
}
</style>
